var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperclip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0797 12.42L12.8997 18.61C11.2178 20.1047 8.66232 20.0295 7.07126 18.4384C5.48019 16.8474 5.40496 14.2919 6.89968 12.61L14.8997 4.61C15.8916 3.66778 17.4478 3.66778 18.4397 4.61C19.408 5.59134 19.408 7.16867 18.4397 8.15L11.5397 15.04C11.3539 15.2401 11.0755 15.3258 10.8094 15.265C10.5432 15.2041 10.3297 15.0059 10.2494 14.745C10.169 14.4841 10.2339 14.2001 10.4197 14L15.5497 8.88C15.9418 8.48788 15.9418 7.85212 15.5497 7.46C15.1576 7.06788 14.5218 7.06788 14.1297 7.46L8.99968 12.6C8.48121 13.1145 8.1896 13.8146 8.1896 14.545C8.1896 15.2754 8.48121 15.9756 8.99968 16.49C10.0888 17.5275 11.8005 17.5275 12.8897 16.49L19.7797 9.59C21.4318 7.81694 21.3831 5.05394 19.6694 3.34027C17.9557 1.6266 15.1927 1.57785 13.4197 3.23L5.41968 11.23C3.17845 13.7123 3.28846 17.519 5.66932 19.8678C8.05018 22.2165 11.8581 22.2748 14.3097 20L20.4997 13.82C20.7533 13.5663 20.8524 13.1966 20.7596 12.8501C20.6667 12.5036 20.3961 12.233 20.0496 12.1401C19.7031 12.0473 19.3333 12.1463 19.0797 12.4V12.42Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default ForwardRef;